import { isFunction } from 'lodash'

export default {
  install(Vue, { throwError = true } = {}) {
    Vue.prototype.$handlingError = async function (
      messageHandler,
      callback,
      options = {}
    ) {
      const { timeout, final, ...snackOptions } = options
      try {
        await callback()
      } catch (error) {
        this.$Sentry.captureException(error)
        this.$showErrorbar(
          isFunction(messageHandler) ? messageHandler(error) : messageHandler,
          timeout,
          snackOptions
        )
        if (throwError) {
          throw error
        }
      } finally {
        if (final) {
          final()
        }
      }
    }
  }
}
